import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Alert, Box, Button, IconButton, TextField } from "@mui/material/";
import makeStyles from "@mui/styles/makeStyles";
import { useParams, useNavigate } from "react-router-dom";
import { Outlet } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import styles from "./styles";
import SearchItem from "./SearchItem";
import useDebounceSearch from "./useDebounceSearch";
import useCombinedLocations from "./useCombinedLocations";
import { useSelector } from "react-redux";
import PlaceIcon from "@mui/icons-material/Place";
import { useCurrentLocation } from "../../common/hooks";

/** Params for search  */
const MIN_SEARCH_LENGTH = 3;

const Search = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [searchText, setSearchText] = useState("");
    const { auditId } = useParams();
    const classes = makeStyles(styles)();
    const combinedLocations = useCombinedLocations(parseInt(auditId));
    const otherAuditLocations = combinedLocations[1];
    const { audits, search } = useSelector((state) => state);
    const searchResult = useDebounceSearch();
    const isGroupAudit = audits?.item?.auditReference.toLowerCase() !== "none";

    const currentLocation = useCurrentLocation();

    const isLinked = (auditAsset: any) =>
        Boolean(
            otherAuditLocations.find(
                (item) => item.id === auditAsset.auditLocation.id
            )
        );

    const onSearchChange = (evt) => {
        const { value } = evt.target;
        setSearchText(value);
        if (value.length >= MIN_SEARCH_LENGTH) searchResult(value);
    };

    const onAddNewAssetPress = () => {
        navigate(`/auth/audits/${auditId}/new-asset`, {
            state: { searchText },
        });
    };

    const AddNewAsset = () => (
        <Box className={classes.addNewAsset} onClick={onAddNewAssetPress}>
            <Button startIcon={<AddIcon />}>{t("addNewAsset")}</Button>
        </Box>
    );

    return (
        <>
            {isGroupAudit && currentLocation.length > 0 && (
                <Alert
                    severity="info"
                    iconMapping={{
                        info: <PlaceIcon fontSize="inherit" />,
                    }}
                    sx={{ mb: 1 }}
                >
                    {currentLocation}
                </Alert>
            )}

            <TextField
                fullWidth
                autoComplete="off"
                id="searchField"
                variant="outlined"
                type="search"
                label={t("search")}
                onChange={onSearchChange}
                value={searchText}
                InputProps={{
                    endAdornment: (
                        <IconButton>
                            <SearchIcon />
                        </IconButton>
                    ),
                }}
            />
            {searchText.length >= MIN_SEARCH_LENGTH ? (
                <Box elevation={2} className={classes.searchListContainer}>
                    {search.results.map((item) => {
                        return (
                            <SearchItem
                                key={item.id}
                                searchText={searchText.toLowerCase()}
                                data={item}
                                isLinked={isLinked(item)}
                            />
                        );
                    })}

                    {search.results.length === 0 && <AddNewAsset />}
                </Box>
            ) : null}
            <Outlet />
        </>
    );
};

export default Search;
